module.exports = __webpack_public_path__ + "img/marshal.png";